<template>
  <div class="videoPay" :style="styles || ''">
    <div :id="videoId"></div>
  </div>
</template>

<script>
  export default {
    props:{
      video: String,
      videoId: String,
      styles:{
        type: Object,
      }
    },
    mounted(){
      this.$nextTick(()=>{
        this.payVideo();
      })
    },
    created(){

    },
    methods:{
      // 阿里云播放器
      payVideo(){
        this.player = new Aliplayer({
              "id": this.videoId,
              "source": this.video,
              // "vid": this.roadShowparam.aliyun_videoId,
              // 'playauth': this.roadShowparam.aliyun_palyAuth,
              "width": "100%",
              "height": "495px",
              "autoplay": false,
              "isLive": false,
              "rePlay": false,
              "playsinline": true,
              "preload": true,
              "controlBarVisibility": "hover",
              "useH5Prism": true,
              "definition": 'FD,SD,HD,OD',
              "defaultDefinition": 'SD',
            }, (player) => {
              // this.player.play();
            }
        );

        //设置播放器中  暂停按钮为居中
        Array.prototype.forEach.call(document.getElementsByClassName('prism-big-play-btn'), function (item) {
          item.style.position = 'absolute'
          item.style.left = 0
          item.style.bottom = 0
          item.style.right = 0
          item.style.top = 0
          item.style.margin = 'auto'
          item.style.display = 'block'
        })

      },
    }
  }
</script>

<style lang="scss" scoped>
.videoPay{

}
</style>
